import React from "react";

const About = () => {
  return (
    <div className="bg-dark text-white">
      {/* About Section */}
      <div className="max-w-6xl mx-auto py-16 px-6 md:flex items-center gap-10">
        <div className="md:w-1/2">
          <h2 className="text-4xl font-bold mb-6 text-primary">
            About Watford Taxi
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed">
          Watford Taxi has been a trusted provider of professional, reliable, and affordable taxi services in Watford for years. Whether it’s a short local trip or a long-distance journey, we’re committed to delivering punctual, comfortable rides every time.
          </p>
          <p className="mt-6 text-gray-300 leading-relaxed">
          Our services cater to a variety of transport needs, including airport transfers, corporate travel, and special event transport. With a fleet of modern vehicles and a team of experienced drivers, our mission is to offer safe, efficient, and hassle-free travel for all our customers.

          </p>
        </div>
        <div className="md:w-1/2">
          <img
            src="/aboutImage1.png"
            alt="Watford Taxi Fleet"
            className="rounded-lg shadow-lg border-4 border-primary w-full transition-transform duration-300 hover:scale-105"
          />
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gradient-to-r from-primary to-primary py-16">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-500">Why Choose Watford Taxi?</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-10 px-6">
            {/* Feature 1 */}
            <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
              <img
                src="/experience.png"
                alt="Experience"
                className="w-16 mx-auto"
              />
              <h3 className="text-xl font-bold mt-4 text-primary">
              Experience
              </h3>
              <p className="text-gray-300 mt-2">
              We’ve been serving the Watford area for years, building a reputation for reliability and quality service.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
              <img
                src="/modernfleet.png"
                alt="Modern Fleet"
                className="w-16 mx-auto"
              />
              <h3 className="text-xl font-bold mt-4 text-primary">
              Modern Fleet
              </h3>
              <p className="text-gray-300 mt-2">
              Our range of vehicles includes saloon cars, MPVs, and executive vehicles, allowing us to meet any need, from individual rides to group transport.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
              <img
                src="/service.png"
                alt="24/7 Availability"
                className="w-16 mx-auto"
              />
              <h3 className="text-xl font-bold mt-4 text-primary">
              24/7 Availability
              </h3>
              <p className="text-gray-300 mt-2">
              Whether it’s an early morning airport transfer or a late-night pick-up, we are available around the clock.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
              <img
                src="/price.png"
                alt="Competitive Pricing"
                className="w-16 mx-auto"
              />
              <h3 className="text-xl font-bold mt-4 text-primary">
              Competitive Pricing
              </h3>
              <p className="text-gray-300 mt-2">
              We believe in transparent pricing with no hidden fees, offering competitive rates for all services.              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Final Section */}
      <div className="max-w-6xl mx-auto py-16 px-6 text-center">
        <h2 className="text-4xl font-bold text-primary">
          A Local Service with a Personal Touch
        </h2>
        <p className="mt-6 text-lg text-gray-300 leading-relaxed">
        As a local business, we understand the community and are dedicated to serving our customers with a personal touch. We’re proud to be part of Watford’s transport network, connecting our customers with the places that matter most to them—whether it’s a regular commute, an important meeting, or the start of a holiday.        </p>
      </div>
    </div>
  );
};

export default About;
